import { useEffect, useRef, useState } from 'react'
import './index.scss'
import LogoSvg from '../../LogoSvg'

const Logo = () => {
  const [rotation, setRotation] = useState(0)
  const [isDragging, setIsDragging] = useState(false)
  const state = useRef({
    dragging: false,
    lastX: 0,
    lastTime: 0,
    velocity: 0,
    rotation: 0,
    rafId: null,
  })

  const handlePointerDown = (e) => {
    const s = state.current
    if (s.rafId) {
      cancelAnimationFrame(s.rafId)
      s.rafId = null
    }
    s.dragging = true
    s.lastX = e.clientX
    s.lastTime = performance.now()
    s.velocity = 0
    setIsDragging(true)
    document.body.classList.add('logo-dragging')
    e.currentTarget.setPointerCapture(e.pointerId)
  }

  const handlePointerMove = (e) => {
    const s = state.current
    if (!s.dragging) return
    const now = performance.now()
    const dt = Math.max(1, now - s.lastTime)
    const dx = e.clientX - s.lastX
    const delta = dx * 0.6
    s.rotation += delta
    s.velocity = (delta / dt) * 16
    s.lastX = e.clientX
    s.lastTime = now
    setRotation(s.rotation)
  }

  const endDrag = (e) => {
    const s = state.current
    if (!s.dragging) return
    s.dragging = false
    setIsDragging(false)
    document.body.classList.remove('logo-dragging')
    try {
      e.currentTarget.releasePointerCapture(e.pointerId)
    } catch (_) {}

    const step = () => {
      s.velocity *= 0.95
      s.rotation += s.velocity
      setRotation(s.rotation)
      if (Math.abs(s.velocity) > 0.05) {
        s.rafId = requestAnimationFrame(step)
      } else {
        s.rafId = null
      }
    }
    s.rafId = requestAnimationFrame(step)
  }

  useEffect(
    () => () => {
      if (state.current.rafId) cancelAnimationFrame(state.current.rafId)
      document.body.classList.remove('logo-dragging')
    },
    []
  )

  return (
    <div className="logo-container">
      <div className={`logo-hover${isDragging ? ' is-dragging' : ''}`}>
        <div
          className="logo-spin"
          style={{ transform: `rotateY(${rotation}deg)` }}
          onPointerDown={handlePointerDown}
          onPointerMove={handlePointerMove}
          onPointerUp={endDrag}
          onPointerCancel={endDrag}
        >
          <LogoSvg className="solid-logo" />
        </div>
        <div className="logo-shadow"></div>
      </div>
    </div>
  )
}

export default Logo
